{
  "eyebrow": "Confirma tu plan",
  "title": "Revisa y configura.",
  "sub": "Puedes cambiar el ciclo de facturación o el plan en cualquier momento desde tu panel de administración.",
  "yourPlan": "Tu plan",
  "changePlan": "Cambiar plan",
  "billing": "Ciclo de facturación",
  "billingMonthLabel": "Pago mensual",
  "billingMonthDesc": "Flexible. Cancela cuando quieras.",
  "billingYearLabel": "Pago anual",
  "billingYearDesc": "~17% de descuento. Facturación anual única.",
  "addons": "Complementos",
  "addon": {
    "ssec": "Seguridad social (check-in/out@work)",
    "ssecDesc": "Solo Bélgica — declaración Dimona automática.",
    "vtt": "Vehicle Track & Trace",
    "vttDesc": "GPS en vivo para vehículos de empresa. +4 €/vehículo/mes.",
    "vehicles": "Vehículos",
    "projectAddon": "Complemento de gestión de proyectos",
    "projectAddonDesc": "Desbloquea las funciones de gestión de proyectos de Time Pro (trabajo adicional, planificación, gestión de subcontratistas)."
  },
  "employees": {
    "title": "¿Cuántos empleados?",
    "active": "usuarios activos",
    "popular": "La mayoría elige {{n}}"
  },
  "estimate": "Coste mensual estimado",
  "estimateNote": "IVA no incluido. Tarifas por usuario según empleados activos.",
  "estimateUnavailable": "Catálogo de precios no disponible. Reintenta para cargar los precios más recientes."
}
